const SCHOOL = "School";
 const COLLEGE = "College"; 
 const PROFESSOR = "Professor";
const TEACHER = "Teacher";
const VISITOR = "Visitor";
const INDUSTRY = "Industry";
const SPONSER = "Sponser";
const SPONSER_INDUSTRY = "Sponser Industry";
 const GOVERNMENT_OFFICER = "GOVERNMENT_OFFICER";


const SUPER_ADMIN = "Super Admin";
const ADMIN = "Super Admin";
const HELPDESK = "Helpdesk";
const VOLUNTEER = "Volunteer";
const FACULTY = "Faculty";

const USER_COLLECTION = "Users";
const VISIT_COLLECTION = "Visits";
const ATTENDANCE_COLLECTION = "Attendance";
const SPONSER_COLLECTION = "SponserCollection";

const COLLEGE_COLOR_FRONT = "#b3a400";
const COLLEGE_COLOR_BACK = "#ffebb5";

const SCHOOL_COLOR_FRONT = "#b3a400";
const SCHOOL_COLOR_BACK = "#ffebb5";

const PROFESSOR_COLOR_FRONT = "#b37400";
const PROFESSOR_COLOR_BACK = "#ffd1b0";

const TEACHER_COLOR_FRONT = "#b37400";
const TEACHER_COLOR_BACK = "#ffd1b0";

const VISITOR_COLOR_FRONT = "#00b327";
const VISITOR_COLOR_BACK = "#b0ffd4";

const SPONSER_COLOR_FRONT = "#d400ff";
const SPONSER_COLOR_BACK = "#efa1ff";

const INDUSTRY_COLOR_FRONT = "#0044b3";
const INDUSTRY_COLOR_BACK = "#b0ceff";

 const GOVERNMENT_OFFICER_COLOR_FRONT = "#0B5D1E"; 
 const GOVERNMENT_OFFICER_COLOR_BACK  = "#CFE9D6"; 

const IITD_TITLE = "IIT Delhi Open House 2025";

function getFrontColor(type) {
  switch (type) {
    case SCHOOL:
      return SCHOOL_COLOR_FRONT;

    case TEACHER:
      return TEACHER_COLOR_FRONT;
  case COLLEGE:
      return COLLEGE_COLOR_FRONT;

    case PROFESSOR:
      return PROFESSOR_COLOR_FRONT;

    case VISITOR:
      return VISITOR_COLOR_FRONT;

    case INDUSTRY:
      return INDUSTRY_COLOR_FRONT;
    case SPONSER:
      return SPONSER_COLOR_FRONT;
    case GOVERNMENT_OFFICER:
      return GOVERNMENT_OFFICER_COLOR_FRONT;

    default:
      return SCHOOL_COLOR_FRONT;
  }
}
function getBackgroundColor(type) {
  switch (type) {
    case SCHOOL:
      return SCHOOL_COLOR_BACK;

    case TEACHER:
      return TEACHER_COLOR_BACK;


          case COLLEGE:
      return COLLEGE_COLOR_BACK;

    case PROFESSOR:
      return PROFESSOR_COLOR_BACK;

    case VISITOR:
      return VISITOR_COLOR_BACK;

    case INDUSTRY:
      return INDUSTRY_COLOR_BACK;
    case SPONSER:
      return SPONSER_COLOR_BACK;
    case GOVERNMENT_OFFICER:
      return GOVERNMENT_OFFICER_COLOR_BACK;

    default:
      return SCHOOL_COLOR_BACK;
  }
}

export {
  SCHOOL,
  COLLEGE,
  PROFESSOR,
  TEACHER,
  USER_COLLECTION,
  VISIT_COLLECTION,
  VISITOR,
  INDUSTRY,
  GOVERNMENT_OFFICER,
  getFrontColor,
  getBackgroundColor,
  SUPER_ADMIN,
  ADMIN,
  HELPDESK,
  IITD_TITLE,
  VOLUNTEER,
  FACULTY,
  ATTENDANCE_COLLECTION,
  SPONSER_COLLECTION,
  SPONSER,
  SPONSER_INDUSTRY,
};
